export default class FileFormatMismatchError extends Error {
}
